import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {MatDialog} from '@angular/material/dialog';
import {SubWindowTextComponent} from '@app/feature/store-editor/components-settings/sub-window-text/sub-window-text.component';
@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.css']
})
export class TEXTComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  @Input() EditText = false;
 
  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  openWindowText() {  
    if (this.EditText) {      
      const windowText = this.dialog.open(SubWindowTextComponent,{
        width: '900px',
        height: '514px',
        data: this.item.data.description,
      });
      windowText.afterClosed().subscribe((res: string) =>{
      if (res) {
          this.item.data.description = res;
        }
      });
    }
  }

}
